import React, { PureComponent } from "react";
import styles from "./Goto.local.scss";

export default class Goto extends PureComponent {
  render() {
    const { url } = this.props;
    return (
      <div className={styles.goto}>
        <input type="text" defaultValue={url} />
        <a href={url} target="_blanc">
          <i className="icon icon-share-alt" />
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Reveal/Goto/index.js